import React from "react";
import styled from "styled-components";
import { rem } from "polished";

const LineContainer = styled.div`
  width: ${rem("750px")};
  margin: ${rem("42px")} auto ${rem("0px")};
  border-bottom: ${rem("1px")} solid #c6c6c6;

  ${({ theme }) => theme.tablet`
    width: unset;
    max-width: ${rem("768px")};
    margin: ${rem("30px")} ${rem("30px")} ${rem("0px")};
  `}
`;

const Line = () => {
  return <LineContainer />;
};

export default Line;
